export const getErrorMessage = (
  errorField: any,
  defaultMessage = "Something went wrong",
): string => {
  const errorFields = Array.isArray(errorField) ? errorField : [errorField];

  for (let i = 0; i < errorFields.length; i++) {
    const errorFieldToLowerCase = errorFields[i]?.toLowerCase();

    if (errorFieldToLowerCase === "undefined" || errorFields[i] === undefined) {
      return defaultMessage;
    }
  }

  return errorField || defaultMessage;
};
